/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'myprofile-root',
  styles: [':host { min-height: 100%; }'],
  templateUrl: './app.component.html',
  standalone: false,
  // Angular 22 changed the implicit default to OnPush (see angular/angular#67687). This component was never migrated
  // to OnPush semantics, so Eager restores the pre-v22 behaviour it relies on.
  // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class AppComponent {
  private translateService = inject(TranslateService)

  constructor() {
    // unfortunately we can not fetch the URL local at this point of time, because the bootstrap url is /auth/callback
    this.translateService.use('en_GB')
  }
}
